const normalizeSearchString = (str: string) =>
  str.toLowerCase().replace(/,/g, "").replace(/\s+/g, " ").trim();

export const filterByNameTerms = (name: string, filter: string): boolean => {
  const terms = normalizeSearchString(filter).split(" ");
  return terms.every((term) => normalizeSearchString(name).includes(term));
};
